import { Pipe, PipeTransform } from '@angular/core';
import { DELIMITER } from './transform-text.pipe';

export interface SearchParameters  {
  searchByDelimiter : DELIMITER,
  actualDelimiter   : DELIMITER,
}
@Pipe({
  name: 'searchFilter'
})

export class SearchFilterPipe implements PipeTransform {

  /**
   * transform
   * @param list - Array of items/strings
   * @param filterKey - String keyword on which filter is based
   * @return any - Collection of filtered items/strings
   */
  transform(list: any[], filterKey: string, filterParams: SearchParameters): any {
    if (!list || !filterKey) {
      return list;
    }
    if(filterParams) {
      filterKey = filterKey.split(filterParams.searchByDelimiter).join(filterParams.actualDelimiter)
    }

    return list.filter(item => {
      let stringifiedItem 
      try{
        stringifiedItem = JSON.stringify(item)
      } catch(e) {
        //----when item is a form control or form group (list is a formArray) ----//
        stringifiedItem = JSON.stringify(item?.value)
      }
      return stringifiedItem.toLowerCase().indexOf(filterKey.toLowerCase()) !== -1});
  }
}
